import React from 'react';

import {CtaButton} from '@optimaxdev/design-system';

import {useSelector} from 'react-redux';

import {useHostSelector} from 'hooks/hostHooks/hostHooks';
import {HostApplicationStoreType} from 'hostApplicationStoreType';
import {flags} from 'libs/rollout';

import s from './appCrashFallback.scss';

type PropsType = {
    platform: string;
    selector: (store: HostApplicationStoreType) => string;
};

/**
 * Fallback which renders if app crashed
 *
 * @returns {React.ReactNode} - react component
 */
export const AppCrashFallback = ({platform, selector}: PropsType) => {
    const orderIdFromHost = useHostSelector(selector);
    const orderIdFromLocal = useSelector(selector);

    let orderId = '';
    if (platform === 'mobile') {
        orderId = flags.mCheckoutMFE.isEnabled() ? orderIdFromLocal : orderIdFromHost;
    }
    if (platform === 'desktop') {
        orderId = orderIdFromLocal;
    }

    const reloadPage = () => {
        window.location.reload();
    };

    return (
        <div className={s.wrapper}>
            <h1 className={s.header}>Looks like something went wrong.</h1>
            {orderId && <p className={s.orderId}>{`Your order id is ${orderId}`}</p>}
            <CtaButton isFull={false} onClick={reloadPage} size="extraSmall">
                Reload page
            </CtaButton>
        </div>
    );
};
